module.exports = __webpack_public_path__ + "img/4 boton inicio portada.ac97606e.svg";